<template>
  <div class="line-style-panel">
      <div class="group">
        Line style：
        <Dropdown v-model="handleLineElement.style"
                  style="flex: 4;"
                  :options="[
                      {label: 'Solid Line', value: 'solid'},
                      {label: 'Dashed Line', value: 'dashed'}]"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Select Line Style"
                  @change="updateLine({ style: handleLineElement.style as 'solid' | 'dashed' })" />
      </div>

    <div class="group">
      Line color：
      <ColorButton @click="$refs.colorPickerVisible.toggle($event)" :color="handleLineElement.color" style="flex: 4" />
      <OverlayPanel ref="colorPickerVisible">
        <ColorPicker
            :modelValue="handleLineElement.color"
            @update:modelValue="value => updateLine({ color: value })"
        />
      </OverlayPanel>
    </div>
    <div class="group">
      Line width:
      <InputNumber
        v-model="lineWidth"
        showButtons
        :step="1"
        style="flex: 3;"
      />
    </div>

    <div class="group">
      Start style:
      <Dropdown v-model="handleLineElement.points[0]"
                style="flex: 4;"
                :options="[
                    {label: 'None', value: ''},
                    {label: 'Arrow', value: 'arrow'},
                    {label: 'Dot', value: 'dot'}]"
                optionLabel="label"
                optionValue="value"
                placeholder="Select Line Style"
                @change="updateLine({ points: [handleLineElement.points[0] as 'arrow' | 'dot', handleLineElement.points[1]] })" />
    </div>
    <div class="group">
      End Style:
      <Dropdown v-model="handleLineElement.points[1]"
                style="flex: 4;"
                :options="[
                    {label: 'None', value: ''},
                    {label: 'Arrow', value: 'arrow'},
                    {label: 'Dot', value: 'dot'}]"
                optionLabel="label"
                optionValue="value"
                placeholder="Select Line Style"
                @change="updateLine({ points: [ handleLineElement.points[0], handleLineElement.points[1]as 'arrow' | 'dot'] })" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import {computed, Ref, watch} from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import { PPTLineElement } from '@/types/slides'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'

import ColorButton from '../common/ColorButton.vue'
import ColorPicker from '@/components/ColorPicker/index.vue'

import useMicroservice from "@/hooks/useMicroservice.ts";
const api = useMicroservice()

const slidesStore = useSlidesStore()
const { handleElement } = storeToRefs(useMainStore())

const handleLineElement = handleElement as Ref<PPTLineElement>

const { addHistorySnapshot } = useHistorySnapshot()

const lineWidth = computed({
  get() {
    return handleLineElement.value.width
  },
  set(val) {
    updateLine({ width: val })
  }
})

watch(handleLineElement, async () => {
  await api.savePresentation()
})

const updateLine = async (props: Partial<PPTLineElement>) => {
  if (!handleElement.value) return
  slidesStore.updateElement({ id: handleElement.value.id, props })
  await api.savePresentation()
  addHistorySnapshot()
}
</script>

<style lang="scss" scoped>
.group {
  margin-top: 10px;
  display: flex;
  align-items: center;
  column-gap: 10px;
}

.row {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  --bs-gutter-x: 0
}

.line-btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 !important;

  .line-wrapper {
    margin-left: 8px;
  }
}
.line-wrapper {
  overflow: visible;
}
.line-btn-icon {
  width: 30px;
  font-size: 12px;
  margin-top: 2px;
  color: #bfbfbf;
}
.preset-point-style {
  padding: 0 10px;

  & + .preset-point-style {
    margin-top: 10px;
  }
}
</style>
